module.exports = __webpack_public_path__ + "static/media/edit.f0bbba86.png";